// @flow strict

import * as React from 'react';

import styles from './ShadowBox.css';

type Props = {|
  inverted: boolean,
  children: React.Node,
|};

const ShadowBox = ({ inverted, children }: Props) => (
  <div className={`${styles.shadowBox}${inverted ? ` ${styles.inverted}` : ''}`}>{children}</div>
);

ShadowBox.defaultProps = {
  inverted: false,
};

export default ShadowBox;
